// extracted by mini-css-extract-plugin
export default {"componentWrapper":"StatusPill_componentWrapper__Lqrsa","active":"StatusPill_active__erUTW","pending":"StatusPill_pending__3v+dy","inactive":"StatusPill_inactive__GDoU6"};